import $ from "jquery";
import { register } from "@shopify/theme-sections";
import {
	getWishlistProducts,
	addToWishlist,
	removeFromWishList,
	onWishlistLoad
} from "../core/helpers/swym";

const selectors = {
	header: "#shopify-section-header",
	cartItem: {
		cartItemsContainer: "[data-cart-items-container]",
		item: "[data-main-cart-item]",
		deleteButton: "[data-cart-item-delete]",
		availabilityLabel: "[data-available-label]",
		availableMessageWrapper: "[data-available-message-wrapper]",
		customizableProduct: "[data-customizable-product]",
		wishlistButtons: "[data-add-to-wishlist]",
		wishlistButtonsPrevent: ".wishlist-button",
		optionalMessage: "[data-optional-message]"
	},
	cartQuantity: {
		wrapper: "[data-quantity-selector]",
		buttons: "[data-quantity-button]",
		decrement: "[data-quantity-decrement-button]",
		input: "[data-quantity-input]",
		increment: "[data-quantity-increment-button]",
		error: "[data-quantity-error-message]"
	},
	storePicker: {
		picker: "[data-store-picker]",
		heading: "[data-store-picker-heading]",
		content: "[data-store-picker-content]",
		item: "[data-store-picker-item]",
		resetItem: "[data-store-picker-reset-item]"
	},
	cartCheckoutBlock: {
		messageWrapper: "[data-checkout-message]",
		only_online: "[data-only-online]",
		full_available: "[data-full-available]",
		subtotal_price: "[data-main-cart-subtotal-price]"
	}
};
const modifiers = {
	load: "load",
	showHeader: "shopify-section-header-sticky animate"
};
const parameters = {
	token: window.storefrontAPIToken.token
};
register("cart", {
	locations: [],
	availabilityStatuses: window.productAvailabilityStatus,
	selectedStore: null,
	productAvailability: {},

	initCart: async function () {
		this.eventInitialization();
		this.checkWishlist();
	},
	checkWishlist: function () {
		onWishlistLoad(async () => {
			const wishlistButtons = $(selectors.cartItem.wishlistButtons);
			$(document).on(
				"click",
				selectors.cartItem.wishlistButtonsPrevent,
				(e) => {
					if (window.screen.width >= 1200) {
						e.preventDefault();
						!$(selectors.header).hasClass(modifiers.showHeader)
							? $(selectors.header).addClass(modifiers.showHeader)
							: null;
						const openWishlistEvent = new Event(
							"openWishlistEvent"
						);
						document.dispatchEvent(openWishlistEvent);
					}
				}
			);
			const wishlistProducts = await getWishlistProducts();
			$(wishlistButtons).each(async (index, item) => {
				const variantId = $(item).attr("data-wishlist");
				const productId = $(item).attr("data-wishlist-prod-id");
				const currentProduct =
					wishlistProducts.find(
						(product) => +product.id === +productId
					) || null;
				if (currentProduct) {
					const currentVariant =
						currentProduct.variants.find(
							(variant) => +variant.id === +variantId
						) || null;
					currentVariant
						? $(item).addClass("wishlist-button--added")
						: null;
				}
			});
		});
	},
	eventInitialization: function () {
		// Delete button
		$(selectors.cartItem.deleteButton).on("click", ({ target }) => {
			this.deleteItem.call(this, target);
		});
		// Quantity input
		$(selectors.cartQuantity.input).on("change", ({ target }) => {
			this.changeItem(target);
		});

		// Quantity buttons
		$(selectors.cartQuantity.buttons).each((_, button) => {
			$(button).on("click", ({ currentTarget }) => {
				this.debounce(this.changeItem, 2000, currentTarget).call(this);
			});
		});

		// WishlistButton
		$(selectors.cartItem.wishlistButtons).on("click", (event) => {
			this.toggleWishlist(event);
		});

		// Store picker
		$(selectors.storePicker.heading).on("click", async () => {
			if (!this.locations.length) {
				await this.getStores();
			}
			if ($(selectors.storePicker.picker).hasClass("active")) {
				$(selectors.storePicker.picker).removeClass("active");
			} else {
				$(selectors.storePicker.picker).addClass("active");
			}
		});
	},
	toggleWishlist: async function ({ currentTarget }) {
		const variantId = $(currentTarget).attr("data-wishlist");
		const productId = $(currentTarget).attr("data-wishlist-prod-id");
		const product = await this.getProductById(productId);
		const variant = product.variants.find(
			(variant) => variant.id === variantId
		);
		if ($(currentTarget).hasClass("wishlist-button--added")) {
			await removeFromWishList(product, variant);
			$(currentTarget).removeClass("wishlist-button--added");
		} else {
			await addToWishlist(product, variant);
			const openWishlistEvent = new Event("openWishlistEvent");
			document.dispatchEvent(openWishlistEvent);

			$(currentTarget).addClass("wishlist-button--added");
		}
	},
	getProductById: async function (id) {
		const handle = (
			await fetch(
				`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`
			)
				.then((response) => response.json())
				.then((response) => response.resources.results.products.shift())
		).handle;

		return await fetch(`/products/${handle}.js`).then((response) =>
			response.json()
		);
	},
	// Store availability
	getStores: async function () {
		const { data } = await fetch(`/api/2022-01/graphql.json`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Shopify-Storefront-Access-Token": parameters.token
			},
			body: JSON.stringify({
				query: `
					query LocationsByDistance($location: GeoCoordinateInput!) {
						locations(near: $location, first: 10, sortKey: DISTANCE) {
						edges {
							node {
								name
							}
						}
						}
					}
				`,
				variables: {
					location: {
						latitude: 52.523287,
						longitude: 13.415478
					}
				}
			})
		})
			.then((response) => response.json())
			.catch((error) => console.error(error));

		if (data) {
			[...data.locations.edges].forEach((location) => {
				this.locations.push(location.node.name);
			});
		}
		this.insertLocations();
	},
	insertLocations: function () {
		const resetLocationField = `<span>Keine Auswahl</span>`;
		const pickupResetLocationItem = $(
			'<button type="button" data-store-picker-reset-item></button>'
		)
			.addClass("store-picker__content__item")
			.html(resetLocationField);
		const globalLocationNames = window.globalStoresList.names.map(
			(location) => location.toLowerCase()
		);
		const globalLocationIndexes = window.globalStoresList.orders;
		let locationButtons = [];
		this.locations.forEach((location) => {
			const pickupLocationItem = $(
				'<button type="button" data-store-picker-item></button>'
			).addClass("store-picker__content__item");
			let currentLocation = null;
			if (
				location.includes("KPM") &&
				!location.toLowerCase().includes("im kadewe")
			) {
				let trimLocation = location
					.toUpperCase()
					.replace("KPM BERLIN", "")
					.trim();
				currentLocation = pickupLocationItem.html(
					`<span>${trimLocation.toUpperCase()}</span>`
				);
			} else if (location.toLowerCase().includes("im kadewe")) {
				let trimLocation = location
					.toUpperCase()
					.replace("KPM BERLIN", "KPM STORE")
					.trim();
				currentLocation = pickupLocationItem.html(
					`<span>${trimLocation.toUpperCase()}</span>`
				);
			} else {
				currentLocation = pickupLocationItem.html(
					`<span>${location.toUpperCase()}</span>`
				);
			}

			const clearLocation = location
				.toLowerCase()
				.replace("kpm", "")
				.replaceAll("berlin", "")
				.trim();

			globalLocationNames.forEach((store, index) => {
				if (store.toLowerCase().includes(clearLocation)) {
					locationButtons[globalLocationIndexes[index]] =
						currentLocation;
				}
			});
		});
		locationButtons.forEach((locationItem) => {
			$(selectors.storePicker.content).append(locationItem);
		});
		const setResetButton = () => {
			$(selectors.storePicker.content).prepend(pickupResetLocationItem);
			$(selectors.storePicker.resetItem).on(
				"click",
				({ currentTarget }) => {
					$(selectors.storePicker.picker).removeClass("active");
					$(selectors.storePicker.heading)
						.html($(currentTarget).html())
						.addClass("select");
					this.selectedStore = null;
					$(currentTarget).remove();
					$(selectors.storePicker.heading).hasClass("select")
						? $(selectors.storePicker.heading).removeClass("select")
						: null;
					$(selectors.cartItem.availableMessageWrapper).each(
						(_, wrap) => {
							$(wrap).addClass("hide");
						}
					);
					$(selectors.cartCheckoutBlock.only_online).removeClass(
						"hide"
					);
					$(selectors.cartCheckoutBlock.full_available).addClass(
						"hide"
					);
				}
			);
		};
		// Events
		$(selectors.storePicker.item).on("click", ({ currentTarget }) => {
			$(selectors.storePicker.picker).removeClass("active");
			$(selectors.storePicker.heading)
				.html($(currentTarget).html())
				.addClass("select");
			this.selectedStore = $(currentTarget).find("span").html();
			setResetButton();
			this.checkItemLocation();
		});
		$(document).on("click", ({ target }) => {
			const item = $(selectors.storePicker.picker);
			if (
				target !== $(selectors.storePicker.heading).get(0) &&
				!$(selectors.storePicker.heading).find(target).length &&
				!item.find(target).length
			) {
				if ($(item).hasClass("active")) {
					$(item).removeClass("active");
				}
			}
		});
	},
	checkItemLocation: async function () {
		const idOfItems = $(selectors.cartItem.item).map((_, item) =>
			$(item).attr("data-id")
		);
		if (idOfItems.length) {
			await Promise.all(
				idOfItems.map((_, id) =>
					fetch(
						`/variants/${id}/?section_id=pickup-availability-cart`
					)
						.then((response) => response.text())
						.then((text) => {
							const documentHTML =
								new DOMParser().parseFromString(
									text,
									"text/html"
								);
							const stores = JSON.parse(
								$(documentHTML)
									.find("[data-pickup-availability]")
									.html()
							).pick_up_availabilities;
							this.updateItemAvailability(stores, id);
						})
						.catch((e) => {
							console.error(e);
						})
				)
			).then(() => {
				this.updateCheckoutAvailabilityMessage();
			});
		}
	},
	updateItemAvailability: function (stores, id) {
		const availabilityLabel = $(selectors.cartItem.item).map((_, item) => {
			if ($(item).attr("data-id") === id) {
				return $(item).find(selectors.cartItem.availabilityLabel);
			}
		});
		const changeLabel = (in_stock) => {
			let isCustomizable = false;
			const customizableProducts = $(
				selectors.cartItem.customizableProduct
			);
			$(selectors.cartItem.item).filter((_, item) => {
				if ($.inArray(item, customizableProducts) !== 0) {
					isCustomizable = true;
				}
			});
			!isCustomizable ? (this.productAvailability[id] = in_stock) : null;
			$(selectors.cartItem.availableMessageWrapper).each((_, wrap) => {
				$(wrap).hasClass("hide") ? $(wrap).removeClass("hide") : null;
			});
			availabilityLabel.each((_, label) => {
				$(label).hasClass("in-stock")
					? $(label).removeClass("in-stock")
					: null;
				$(label).hasClass("out") ? $(label).removeClass("out") : null;
			});
			if (in_stock) {
				availabilityLabel.each((_, label) => {
					label
						.html(this.availabilityStatuses.in_stock)
						.addClass("in-stock");
					!$(label).next().hasClass("hide")
						? $(label).next().addClass("hide")
						: null;
				});
			} else {
				availabilityLabel.each((_, label) => {
					label
						.html(`${this.availabilityStatuses.out_of_stock}.`)
						.addClass("out");
					$(label).next().hasClass("hide")
						? $(label).next().removeClass("hide")
						: null;
				});
			}
		};
		if (!stores.length) {
			changeLabel(false);
		} else {
			const currentStore = stores.find((store) => {
				const storeName = Object.keys(store).map((store) => {
					if (store.includes("ß")) {
						return store.replace("ß", "ss");
					}
					return store;
				});
				const updatedStoreName = this.editLocationName(storeName[0]);

				if (
					updatedStoreName.includes(this.selectedStore.toLowerCase())
				) {
					return store;
				}
			});
			if (currentStore) {
				Object.keys(currentStore).length
					? changeLabel(Object.values(currentStore)[0])
					: changeLabel(false);
			} else {
				changeLabel(false);
			}
		}
	},

	editLocationName: function (location) {
		let trimLocation;
		if (
			location.includes("KPM") &&
			!location.toLowerCase().includes("im kadewe")
		) {
			trimLocation = location
				.toUpperCase()
				.replace("KPM BERLIN", "")
				.trim();
		} else if (location.toLowerCase().includes("im kadewe")) {
			trimLocation = location
				.toUpperCase()
				.replace("KPM BERLIN", "KPM STORE")
				.trim();
		} else {
			trimLocation = location;
		}
		return trimLocation.toLowerCase();
	},

	updateCheckoutAvailabilityMessage: function () {
		let outOfStockMessage = $(selectors.cartItem.availabilityLabel);
		$(selectors.cartCheckoutBlock.only_online).addClass("hide");
		$(selectors.cartCheckoutBlock.full_available).removeClass("hide");

		for (let i = 0; i < outOfStockMessage.length; i++) {
			if ($(outOfStockMessage[i]).hasClass("out")) {
				$(selectors.cartCheckoutBlock.full_available).addClass("hide");
				$(selectors.cartCheckoutBlock.only_online).removeClass("hide");
				break;
			}
		}
	},
	// End store availability

	// Button event handle
	debounce: function (callback, delay, event) {
		let timeout;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(callback.call(this, event), delay);
		};
	},
	changeItem: function (target) {
		const currentItem = $(target)
			.parents()
			.filter(selectors.cartItem.item)
			.get(0);
		const cartItemId = +$(currentItem).attr("data-id");
		const decrementButton = $(currentItem).find(
			selectors.cartQuantity.decrement
		);
		const incrementButton = $(currentItem).find(
			selectors.cartQuantity.increment
		);
		const currentInput = $(currentItem).find(selectors.cartQuantity.input);
		const errorMessage = $(currentItem).find(selectors.cartQuantity.error);

		let count = null;
		if (target === decrementButton.get(0)) {
			count = +currentInput.val() - 1;
			if (count.toString().length < 3) {
				$(selectors.cartQuantity.wrapper).hasClass("large")
					? $(selectors.cartQuantity.wrapper).removeClass("large")
					: null;
			}
		} else if (target === incrementButton.get(0)) {
			count = +currentInput.val() + 1;
			if (count.toString().length >= 3) {
				!$(selectors.cartQuantity.wrapper).hasClass("large")
					? $(selectors.cartQuantity.wrapper).addClass("large")
					: null;
			}
		} else if (target === currentInput.get(0)) {
			count = +currentInput.val();
			if (count.toString().length >= 3) {
				!$(selectors.cartQuantity.wrapper).hasClass("large")
					? $(selectors.cartQuantity.wrapper).addClass("large")
					: null;
			} else if (count.toString().length < 3) {
				$(selectors.cartQuantity.wrapper).hasClass("large")
					? $(selectors.cartQuantity.wrapper).removeClass("large")
					: null;
			}
			if (count >= 9999) {
				count = 9999;
				currentInput.val(9999);
				errorMessage.addClass("show");
				setTimeout(() => {
					errorMessage.removeClass("show");
				}, 3000);
			}
			if (count <= 0) {
				count = $(currentInput).attr("min");
				currentInput.val($(currentInput).attr("min"));
			}
		}
		if (count === 0) {
			count = 1;
			currentInput.val(1);
			return;
		} else if (!count) {
			return;
		}
		const data = {
			id: cartItemId,
			quantity: count
		};
		const highThis = this;
		$(selectors.cartQuantity.wrapper).addClass(modifiers.load);
		$.ajax({
			url: "/cart/change.js",
			method: "post",
			dataType: "json",
			data,
			success: function (response) {
				$("[data-header-icon-cart-count]").html(response.item_count);
				const quantity = response.items.find(
					(item) => +item.id === +cartItemId
				).quantity;
				if (+count > +quantity) {
					errorMessage.addClass("show");
					currentInput.val(quantity);
					setTimeout(() => {
						errorMessage.removeClass("show");
					}, 3000);
					return;
				} else {
					currentInput.val(count);
					highThis.updateSubtotalPrice();
				}
				$(selectors.cartQuantity.wrapper).removeClass(modifiers.load);
			},
			error: function () {
				$(selectors.cartQuantity.wrapper).removeClass(modifiers.load);
			}
		});
	},
	deleteItem: function (target) {
		const currentItem = $(target)
			.parents()
			.filter(selectors.cartItem.item)
			.get(0);
		const cartItemId = $(currentItem).attr("data-id");

		const data = {
			updates: {
				[cartItemId]: 0
			}
		};

		const successFn = (response) => {
			$(currentItem).remove();
			if (this.productAvailability.hasOwnProperty(cartItemId)) {
				delete this.productAvailability[cartItemId];
			}
			this.updateSubtotalPrice();
			$("[data-header-icon-cart-count]").addClass("hidden").text("");
			if (+response.item_count > 0) {
				$("[data-header-icon-cart-count]")
					.removeClass("hidden")
					.text(response.item_count);
			}
		};

		$.ajax({
			url: "/cart/update.js",
			method: "post",
			dataType: "json",
			data: data,
			success: (response) => successFn(response),
			error: function (error) {
				console.log(error);
			}
		});
	},
	getUpdatedCart: async function (selectors) {
		const url = `/cart/?section_id=main-cart`;
		const response = await fetch(url)
			.then((res) => res.text())
			.then((text) => {
				return new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector(`${selectors}`);
			});
		const result = await fetch("/cart/update.js")
			.then((response) => response.json())
			.catch((error) => console.log(error));
		if (result) {
			const length = result.items.length;
			if (!length) {
				window.location.reload();
			}
		}
		return response;
	},
	updateSubtotalPrice: async function () {
		const updatedPrice = await this.getUpdatedCart(
			".main-cart-footer__checkout__subtotal .subtotal__price"
		);
		$(selectors.cartCheckoutBlock.subtotal_price).html(
			$(updatedPrice).html()
		);
	},
	onLoad: function () {
		this.initCart();
	}
});
